module.exports = __webpack_public_path__ + "static/media/IMG_4136.92bb8295.jpg";